var map = {
	"./slolution-1.png": 804,
	"./slolution-2.png": 805,
	"./slolution-3.png": 806,
	"./slolution-4.png": 807,
	"./slolution-5.png": 808,
	"./slolution-6.png": 809,
	"./slolution-7.png": 810,
	"./slolution-8.png": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1930;